<template>
  <div>
    <PageLoader />
    <ServerError v-if="ServerError" />
    <v-app id="inspire">
      <v-layout wrap justify-center class="login_page">
        <v-flex xs12 sm6 md4 lg3 px-2 align-self-center>
          <v-layout wrap justify-center>
            <v-flex xs112 xl10>
              <v-snackbar
                v-model="showSnackBar"
                color="#005f32"
                right
                :timeout="timeout"
              >
                <v-layout wrap justify-center>
                  <v-flex text-left class="align-self-center">
                    <span style="color: #ffffff">
                      {{ msg }}
                    </span>
                  </v-flex>
                  <v-flex text-right>
                    <v-btn
                      small
                      :ripple="false"
                      text
                      @click="showSnackBar = false"
                    >
                      <v-icon style="color: #ffffff">mdi-close</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-snackbar>
              <v-card
                tile
                elevation="5"
                class="rounded-xl"
                style="border-bottom: 3px solid #15560b"
              >
                <v-layout wrap justify-center>
                  <v-flex px-8 py-6>
                    <v-layout wrap justify-center>
                      <v-flex xs12>
                        <span
                          style="
                            font-family: kumbhMedium;
                            font-size: 15px;
                            color: #b8b8b8;
                          "
                        >
                          Welcome to
                        </span>
                      </v-flex>
                      <v-flex xs12 py-4 style="cursor: pointer">
                        <router-link to="/">
                          <span
                            style="
                              font-family: kumbhEBold;
                              font-size: 20px;
                              cursor: pointer;
                              color: #545454;
                            "
                          >
                            WTI
                          </span>
                        </router-link>
                      </v-flex>
                      <v-flex xs12>
                        <v-layout wrap justify-center>
                          <v-flex xs6 lg4 px-2>
                            <span
                              style="
                                font-family: poppinssemibold;
                                font-size: 15px;
                                color: #000;
                              "
                            >
                              Log In
                            </span>
                            <v-progress-linear
                              height="2"
                              value="100"
                              color="#005f32"
                            ></v-progress-linear>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex
                        pt-8
                        xs12
                        text-left
                        v-if="!chooseFlag && !pretoken"
                      >
                        <v-layout wrap justify-center>
                          <v-flex xs12>
                            <v-form @submit.prevent="validateInput">
                              <v-text-field
                                color="#717171"
                                label="Email / Employee ID"
                                outlined
                                dense
                                v-model="phone"
                                hide-details
                                class="rounded-xl"
                              >
                              </v-text-field>
                            </v-form>
                          </v-flex>
                        </v-layout>
                        <v-layout wrap justify-center pt-4>
                          <v-flex xs12>
                            <v-form @submit.prevent="validateInput">
                              <v-text-field
                                color="#717171"
                                label="Password"
                                outlined
                                dense
                                v-model="password"
                                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="show1 ? 'text' : 'password'"
                                @click:append="show1 = !show1"
                                hide-details
                                class="rounded-xl"
                              >
                              </v-text-field>
                            </v-form>
                          </v-flex>
                        </v-layout>
                      </v-flex>

                      <!-- Choose Role  -->

                      <v-flex pt-8 xs12 align-self-center text-left v-else>
                        <v-layout wrap justify-center>
                          <v-flex xs12 pa-2 align-self-center text-center>
                            <span class="kumbhMedium">Choose Position</span>
                          </v-flex>
                          <v-flex xs12 align-self-center py-2>
                            <v-divider></v-divider>
                          </v-flex>
                          <v-flex xs12 align-self-center text-center>
                            <v-radio-group dense v-model="position">
                              <v-radio
                                style="font-family: KumbhMedium !important"
                                color="#005f32"
                                v-for="(item, i) in positionList"
                                :key="i"
                                :label="item.name"
                                :value="item._id"
                                :title="item.project.projectName"
                              ></v-radio>
                            </v-radio-group>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <!-- <v-flex pt-2 xs12 text-left>
                        <router-link to="/ForgotPassword">
                          <span
                            style="
                              font-family: poppinssemibold;
                              font-size: 12px;
                              text-transform: none;
                            "
                          >
                            Forgot Password ?
                          </span>
                        </router-link>
                      </v-flex> -->
                      <v-flex xs12 lg5 py-6 v-if="!chooseFlag && !pretoken">
                        <v-btn
                          block
                          tile
                          dark
                          color="#005f32"
                          light
                          :ripple="false"
                          depressed
                          @click="validateInput"
                          class="itemValue rounded-xl"
                        >
                          Login
                        </v-btn>
                      </v-flex>
                      <v-flex xs12 lg5 py-6 v-if="chooseFlag || pretoken">
                        <v-btn
                          block
                          tile
                          dark
                          color="#005f32"
                          light
                          :ripple="false"
                          depressed
                          @click="applyRole()"
                          class="itemValue rounded-xl"
                        >
                          Continue
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-app>
  </div>
</template>
<script>
import axios from "axios";
import store from "./../../store";
export default {
  data() {
    return {
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      phone: null,
      password: null,
      chooseFlag: false,
      position: null,
      positionList: null,
      pretoken: null,
      show1: false,
    };
  },
  beforeMount() {
    this.pretoken = localStorage.getItem("pretoken");
    // this.positionList=localStorage.getItem('prepositions')
    if (this.pretoken) {
      this.getPreserve();
    }
    if (localStorage.getItem("token")) localStorage.removeItem("pretoken");
  },
  methods: {
    getPreserve() {
      axios({
        method: "GET",
        url: "employee/profile/me",
        headers: {
          "x-auth-token": localStorage.getItem("pretoken"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.positionList = response.data.data.positionid;
          } else {
            this.$store.commit("appLoading", false);
          }
        })
        .catch((err) => {
          this.$store.commit("appLoading", false);
          console.log(err);
        });
    },
    validateInput() {
      if (!this.phone) {
        this.msg = "Please Provide Phone";
        this.showSnackBar = true;
        return;
      } else if (!this.password) {
        this.msg = "Please Provide Password";
        this.showSnackBar = true;
        return;
      } else {
        this.login();
      }
    },
    login() {
      var userData = {};
      // userData["accessType"] = "signin";
      userData["username"] = this.phone;
      userData["password"] = this.password;
      store.commit("appLoading", true);
      axios({
        method: "POST",
        url: "employee/login",
        data: userData,
      })
        .then((response) => {
          store.commit("appLoading", false);
          if (response.data.status) {

             localStorage.setItem("positionId",response.data.position)
            store.commit("userData", response.data.data);
            this.$store.commit("fullData", response.data);
            store.commit("menu", response.data.menus);
            if (response.data.data.positionid) {
              if (response.data.data.positionid.length > 1) {
                localStorage.setItem("pretoken", response.data.token);
                this.positionList = response.data.data.positionid;
                localStorage.setItem("prepositions", this.positionList);
                this.chooseFlag = true;
              } else {
                this.chooseFlag = false;
                store.commit("loginUser", response.data.token);
              }

            }
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          store.commit("appLoading", false);
          this.ServerError = true;
          console.log(err);
        });
    },

    applyRole() {
      if (!this.position) {
        this.msg = "Please choose a position!";
        this.showSnackBar = true;
        return;
      }
      var userData = {};
      userData["position"] = this.position;
      store.commit("appLoading", true);
      axios({
        method: "POST",
        url: "/employee/switchposition",
        data: userData,
        headers: {
          "x-auth-token": localStorage.getItem("pretoken"),
        },
      })
        .then((response) => {
          store.commit("appLoading", false);
          if (response.data.status) {
            localStorage.removeItem("pretoken");
            store.commit("userData", response.data.data);
            this.$store.commit("fullData", response.data);
            store.commit("menu", response.data.menus);
            store.commit("loginUser", response.data.token);
            console.log("logmenu", response.data.menus);
            this.chooseFlag = false;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          store.commit("appLoading", false);
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
